module.exports = __webpack_public_path__ + "img/friendadd-fill.ad3b00d8.svg";